import Logo from './Logo';
export default Logo;
//# sourceMappingURL=index.js.map